import React, { useContext, useEffect, useRef } from "react";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useAuth, useTextDomainContext } from "@/app/providers";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate, useSearchParams } from "react-router";
import { useSendWelcomeEmail, useVerifyUserByToken } from "./hooks";

/**
 *
 */
export function ConfirmEmailRedirectFlow() {
  const { isAuthenticated } = useAuth();

  const { TextDomainContext } = useTextDomainContext();

  const { enqueueSnackbar } = useSnackbar();

  const { gettext } = useContext(TextDomainContext);

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const token = searchParams.get("token");

  const { sendEmail } = useSendWelcomeEmail(
    () => {},
    () => {},
  );

  const { verify, isConfirmed, email } = useVerifyUserByToken((_error) => {
    enqueueSnackbar("Failed to verify", {
      variant: "error",
    });
    navigate("/auth/login");
  });

  const verifiedTokenRef = useRef<string | null>(null);

  useEffect(() => {
    if (token) {
      if (verifiedTokenRef.current !== token) {
        verifiedTokenRef.current = token;
        verify(token);
      }
    } else {
      enqueueSnackbar(gettext("Invalid verification link"), {
        variant: "error",
      });
      navigate("/auth/login");
    }
  }, [verify, token, gettext, enqueueSnackbar, navigate]);

  const welcomeSentRef = useRef<string | null>(null);

  useEffect(() => {
    if (email && welcomeSentRef.current !== email) {
      welcomeSentRef.current = email;
      sendEmail(email);
    }
  }, [sendEmail, email]);

  const handleClick = () => {
    if (isAuthenticated) {
      navigate("/");
    } else {
      // window.open("https://www.fabeke.com/", "_self");
      window.open("/", "_self");
    }
  };

  return isConfirmed ? (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: "100px",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Grid>
        <CheckCircleIcon
          color="primary"
          sx={{
            width: "64px",
            height: "64px",
          }}
        />
      </Grid>
      <Grid>
        <Typography
          sx={{
            fontSize: 36,
            fontWeight: 700,
            lineheight: 24,
          }}
        >
          {gettext("Verification Successful")}
        </Typography>
      </Grid>
      <Grid
        container
        sx={{
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: "#52525B",
            lineheight: 14,
          }}
        >
          {gettext(
            "Congratulations, you’ve chosen the best energy spending platform",
          )}
        </Typography>
      </Grid>
      <Grid>
        <Typography
          sx={{
            mt: -2,
            fontSize: 18,
            fontWeight: 500,
            color: "#52525B",
            lineheight: 14,
          }}
        >
          {gettext("You can continue to use our services now. ")}
        </Typography>
      </Grid>
      <Grid>
        <Button
          sx={{
            backgroundColor: "#27272A",
            "&:hover": {
              backgroundColor: "#27272A",
            },
          }}
          variant="contained"
          size="large"
          onClick={handleClick}
          // onClick={() =>
          //   isAuthenticated ?
          //     navigate("/")
          //     :  window.open("https://www.fabeke.com/", "_self")}
        >
          {gettext("Go to App")}
        </Button>
      </Grid>
    </Grid>
  ) : (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
